// API 配置文件
const config = {
  // 后端API基础URL 使用相对路径，通过 devServer 代理到后端
  // apiBaseUrl: process.env.VUE_APP_API_BASE_URL ,
  apiBaseUrl: '/api',

  
  // 其他全局配置
  defaultRegion: 'us-east-1',
  defaultOS: 'Linux',
  defaultDiskSize: 30
}

export default config; 